module.exports = __webpack_public_path__ + "static/media/home-background-artiste-big.fec59180.png";